export default __webpack_public_path__ + "static/media/8S.16d9a1a9.png";